import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/lang'
import './plugins/vant'
import './css/main.scss'
import api from './api/api'
import VueLuckyCanvas from '@lucky-canvas/vue'
import VueSeamLessScroll from 'vue-seamless-scroll'

Vue.use(VueSeamLessScroll)
Vue.use(VueLuckyCanvas)

Vue.config.productionTip = false
Vue.prototype.$api = api

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
